import type { FC } from "react";
import classnames from "classnames";
import styles from "./HorizontalSeparator.module.scss";

export const HorizontalSeparator: FC<{ className?: string }> = ({
  className,
}) => {
  return <hr className={classnames(styles.separator, className)} />;
};
